var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { Color } from '../const/';
import styled from 'styled-components';
import ValidationTooltip from '../tooltip/validation-tooltip';
var TextArea = (function (_super) {
    __extends(TextArea, _super);
    function TextArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextArea.prototype.focus = function () {
        this.input && this.input.focus();
    };
    TextArea.prototype.render = function () {
        var _this = this;
        var _a = this.props, invalidMessage = _a.invalidMessage, getTooltipContainer = _a.getTooltipContainer, toolTipPlacement = _a.toolTipPlacement, props = __rest(_a, ["invalidMessage", "getTooltipContainer", "toolTipPlacement"]);
        return (React.createElement(ValidationTooltip, { placement: toolTipPlacement || 'topLeft', visible: typeof invalidMessage === 'string' && invalidMessage.length > 0, invalidMessage: invalidMessage, getTooltipContainer: getTooltipContainer },
            React.createElement(StyledTextField, { invalidMessage: invalidMessage },
                React.createElement("textarea", __assign({}, props, { ref: function (ref) { return (_this.input = ref); } })))));
    };
    TextArea.defaultProps = {
        name: '',
    };
    return TextArea;
}(React.Component));
var StyledTextField = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n\n  > textarea {\n    background: ", ";\n    border: ", ";\n    border-radius: 4px;\n    box-sizing: border-box;\n    font-size: 14px;\n    height: 148px;\n    line-height: normal;\n    padding: 8px 6px;\n    width: 100%;\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    &::-ms-input-placeholder {\n      color: ", ";\n    }\n\n    &:hover,\n    &:focus {\n      border-color: ", ";\n    }\n  }\n"], ["\n  position: relative;\n  width: 100%;\n\n  > textarea {\n    background: ", ";\n    border: ",
    ";\n    border-radius: 4px;\n    box-sizing: border-box;\n    font-size: 14px;\n    height: 148px;\n    line-height: normal;\n    padding: 8px 6px;\n    width: 100%;\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    &::-ms-input-placeholder {\n      color: ", ";\n    }\n\n    &:hover,\n    &:focus {\n      border-color: ", ";\n    }\n  }\n"])), Color.BACKGROUND_COLOR, function (_a) {
    var invalidMessage = _a.invalidMessage;
    return invalidMessage
        ? "1px solid " + Color.SOFT_RED
        : "1px solid " + Color.LIGHT_GRAY_2;
}, Color.LIGHT_GRAY_2, Color.LIGHT_GRAY_2, Color.VIVID_BLUE);
export default TextArea;
var templateObject_1;
//# sourceMappingURL=text-area.js.map